/* RESON V2 - before-after.js
   Drives the comparison slider's reveal from a real <input type="range">, so
   touch, mouse and keyboard all work for free. The starting split is already
   inlined by Liquid, so the section still renders correctly with JS off. */
(function () {
  function init(frame) {
    if (frame.dataset.baReady === '1') return;
    var range = frame.querySelector('[data-ba-range]');
    if (!range) return;

    function paint() {
      /* --split positions the clip and divider; --splitn is the same value
         unitless, so CSS can fade each label as the divider crosses it */
      frame.style.setProperty('--split', range.value + '%');
      frame.style.setProperty('--splitn', range.value);
    }

    /* A label should dissolve over its own width, not at some fixed distance from
       the frame edge, so sliding the divider across it is what makes it vanish.
       CSS interpolates; this only publishes each label's box as the window to fade
       over, in percent of the frame. Re-run whenever that box can move. */
    function measure() {
      var w = frame.clientWidth;
      if (!w) return;
      var origin = frame.getBoundingClientRect().left;

      function span(sel, edgeProp, edge, scaleProp) {
        var el = frame.querySelector(sel);
        if (!el) return;
        var r = el.getBoundingClientRect();
        var lo = ((r.left - origin) / w) * 100;
        var hi = ((r.right - origin) / w) * 100;
        frame.style.setProperty(edgeProp, (edge === 'lo' ? lo : hi).toFixed(3));
        frame.style.setProperty(scaleProp, (1 / Math.max(hi - lo, 1)).toFixed(5));
      }

      /* before: opaque once the divider clears its right edge, gone at its left */
      span('.ba__label--before', '--lbl-b0', 'lo', '--lbl-bs');
      /* after: opaque until the divider reaches its left edge, gone past its right */
      span('.ba__label--after', '--lbl-a1', 'hi', '--lbl-as');
    }

    range.addEventListener('input', paint);
    range.addEventListener('change', paint);

    if (window.ResizeObserver) {
      new ResizeObserver(measure).observe(frame);
    } else {
      window.addEventListener('resize', measure);
    }
    /* the heading font only changes the label width once it lands */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);

    frame.dataset.baReady = '1';
    paint();
    measure();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-before-after]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
